/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import * as XLSX from "xlsx";
import axios from "axios";
import { pickBy, keys, isEmpty, mapKeys, trim } from "lodash";

/**
 *
 */
export class ExcelHelper {

    workbook: any = null;
    activeSheet: any = null;

    /**
     *
     */
    public async read(excelUrl) {

        if ( !excelUrl ) {
            window.console.log("ExcelHelper : Invalid excelUrl" + excelUrl);
            return;
        }

        const result = await axios.request({
            responseType: "arraybuffer",
            url: excelUrl,
            method: "get",
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
        });

        let data = new Uint8Array(result.data);
        this.workbook = XLSX.read(data, {type: "array"});
        this.workbook.Sheets = mapKeys(this.workbook.Sheets, (sheet, sheetName) => trim(sheetName));

        if ( !this.workbook ) {
            window.console.log("ExcelHelper : Invalid excelUrl" + excelUrl);
        }
    }

    /**
     *
     * @param sheetName
     */
    public setActiveSheet(sheetName) {
        if ( this.workbook.Sheets && this.workbook.Sheets[sheetName] ) {
            this.activeSheet = this.workbook.Sheets[sheetName];
        } else {
            window.console.log("ExcelHelper : Invalid sheetName" + sheetName);
        }
    }

    /**
     *
     * @param rangeRef
     * @returns {{}}
     */
    public getRangeCells(rangeRef): {} {
        let range = XLSX.utils.decode_range(rangeRef);
        let cells = {};
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                let cellAddress = {c: C, r: R};
                let cellRef = XLSX.utils.encode_cell(cellAddress);
                cells[cellRef] = this.activeSheet[cellRef];
            }
        }
        return cells;
    }

    /**
     *
     * @param rangeRef
     * @param value
     * @returns {any}
     */
    public findInRange(rangeRef, value): any {
        let cells = this.getRangeCells(rangeRef);
        if ( cells ) {
            return pickBy(cells, (object: any) => {
                if ( isNaN(parseFloat(value)) ) {
                    return ( object && object.v && object.v === value );
                } else {
                    return ( object && object.v && parseFloat(object.v) === parseFloat(value) );
                }
            });
        } else {
            return null;
        }
    }

    /**
     *
     * @param range1Ref
     * @param value1
     * @param range2Ref
     * @param value2
     * @returns {any}
     */
    public findProductInRanges(range1Ref, value1, range2Ref, value2): any {
        let cells1 = this.findInRange(range1Ref, value1);
        let cells2 = this.findInRange(range2Ref, value2);
        if ( !isEmpty(cells1) && !isEmpty(cells2) ) {
            return this.getProductCell(keys(cells1)[0], keys(cells2)[0]);
        } else {
            return null;
        } 
    }

    /**
     *
     * @param cell1Ref
     * @param cell2Ref
     * @returns {any}
     */
    public getProductCell(cell1Ref, cell2Ref): any {
        let cell1Address = XLSX.utils.decode_cell(cell1Ref);
        let cell2Address = XLSX.utils.decode_cell(cell2Ref);
        let cellResultAddress = {c: cell1Address.c, r: cell2Address.r};
        let cellResultRef = XLSX.utils.encode_cell(cellResultAddress);
        return this.activeSheet[cellResultRef];
    }

}


// WEBPACK FOOTER //
// ./src/helper/Excel.helper.ts